import j from "./common/themes/shared/current/colors.mjs";
import g from "./common/themes/shared/next/colors.mjs";
function a(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function p(t) {
  if (a(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function O(t) {
  return a(t) === "Symbol";
}
function f(t, e, s, o) {
  const u = {}.propertyIsEnumerable.call(o, e) ? "enumerable" : "nonenumerable";
  u === "enumerable" && (t[e] = s), u === "nonenumerable" && Object.defineProperty(t, e, {
    value: s,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function i(t, e, s) {
  if (!p(e))
    return e;
  let o = {};
  if (p(t)) {
    const l = Object.getOwnPropertyNames(t), c = Object.getOwnPropertySymbols(t);
    o = [...l, ...c].reduce((n, r) => {
      const b = t[r];
      return (!O(r) && !Object.getOwnPropertyNames(e).includes(r) || O(r) && !Object.getOwnPropertySymbols(e).includes(r)) && f(n, r, b, t), n;
    }, {});
  }
  const u = Object.getOwnPropertyNames(e), m = Object.getOwnPropertySymbols(e);
  return [...u, ...m].reduce((l, c) => {
    let n = e[c];
    const r = p(t) ? t[c] : void 0;
    return r !== void 0 && p(n) && (n = i(r, n)), f(l, c, n, e), l;
  }, o);
}
function P(t, ...e) {
  return e.reduce((s, o) => i(s, o), t);
}
const T = P(j, {
  next: g
});
export {
  T as C,
  P as m
};
